module.exports = __webpack_public_path__ + "static/media/alert-light@2x.0f6078ad.png";